angular.module('bmsApp.settings').factory('OnlineTermsSvc', function ($http, $log, $window, $q, CRUDSvc) {

	return {
		read: function (licenseId) {
			return CRUDSvc.get('api/settings/online-term/read/' + licenseId);
		},
		save: function (params) {
			return CRUDSvc.post('api/settings/online-term/save', params);
		}
	}

});

